import React, { Component } from 'react';


class Upload extends Component {
    render() {
        let className = "upload-box-wrapper upload-align";
        return (
          <div className={className}>
              <label htmlFor={this.props.id} className="upload-box">
                  <i className="mdi mdi-attachment"></i>
              </label>
              <input id={this.props.id} type={this.props.files ? !this.props.files.length ? "file": '' : 'file'} className="hide" onChange={this.props.fileUpload} multiple />
          </div>
        );
    }
}

export default Upload;



// WEBPACK FOOTER //
// ./src/components/common/Upload.jsx